export default "__VITE_ASSET__zVEcSefO__"